import { createFileRoute } from '@tanstack/react-router';

import { PartnerOverview } from '~/modules/partners/PartnerOverview';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';

const title = 'Geschäftspartner';

export const Route = createFileRoute('/(main)/settings/partner-settings/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/partner-settings',
    ...routeParams,
  }),
  component: PartnerOverview,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const PARTNER_SETTINGS_PAGE = buildRouteExport({
  Route,
  ...routeParams,
});
